import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'app/shared/shared.module';
import { RoleFacade } from 'app/shared/services/facades/role.facade';
import { RoleService } from 'app/shared/services/role.service';
import { RolesSidepanelComponent } from 'app/roles/overview/sidepanel/roles-sidepanel.component';
import { RolesLayoutComponent } from 'app/roles/overview/layout/roles-layout.component';
import { RolesOverviewComponent } from 'app/roles/overview/overview/roles-overview.component';
import { RoleDetailsComponent } from 'app/roles/detail/role-details.component';
import { RoleDetailsGeneralComponent } from 'app/roles/detail/role-details-general.component';
import { RolesNavigatorHelper } from 'app/roles/roles-navigator-helper';
import { RoleEntityResolver } from 'app/shared/components/entity-resolvers/role.entity-resolver';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RoleDetailsPermissionsetsComponent } from 'app/roles/detail/role-details-permissionsets.component';
import { RoleDetailsUsersComponent } from 'app/roles/detail/role-details-users.component';
import { TableModule } from 'primeng/table';
import { TreeModule } from 'primeng/tree';
import { RolesRoutingModule } from './roles-routing.module';

@NgModule({
  declarations: [
    RolesLayoutComponent,
    RolesSidepanelComponent,
    RolesOverviewComponent,
    RoleDetailsComponent,
    RoleDetailsGeneralComponent,
    RoleDetailsPermissionsetsComponent,
    RoleDetailsUsersComponent,
  ],
  imports: [CommonModule, SharedModule, ReactiveFormsModule, FormsModule, TableModule, RolesRoutingModule, TreeModule],
  exports: [
    RolesLayoutComponent,
    RolesSidepanelComponent,
    RolesOverviewComponent,
    RoleDetailsComponent,
    RoleDetailsGeneralComponent,
    RoleDetailsPermissionsetsComponent,
    RoleDetailsUsersComponent,
  ],
  providers: [RoleFacade, RoleService, RoleEntityResolver, RolesNavigatorHelper],
})
export class RolesModule {}
